import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomerDashboardService } from 'src/app/pages/customer-dashboard/services/customer-dashboard.service';
import { CommonService } from 'src/app/services/common.service';
@Component({
  selector: 'app-edit-property',
  templateUrl: './edit-property.component.html',
  styleUrls: ['./edit-property.component.scss'],
})
export class EditPropertyComponent implements OnInit {
  ngUnsubscribe =  new Subject<void>();
  propertySize: any[] = [];
  propertySizeWithPropertyType: any[] = [];
  propertyForm = new FormGroup({
    selectedPropertyType: new FormControl('', [Validators.required]),
    selectedPropertySize: new FormControl('', [Validators.required]),
  });
  constructor(
    public dialogRef: MatDialogRef<EditPropertyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    private cdRef: ChangeDetectorRef,
    private customerDashboardService: CustomerDashboardService,
  ) {}

  ngOnInit(): void {
    this.getPropertySizeWithPropertyType();
    this.propertyForm.setValue({
      selectedPropertyType: this.data.selectedPropertyType,
      selectedPropertySize: this.data.selectedPropertySize,
    });
  }
  close() {
    this.propertyForm.get('selectedPropertySize')?.setValue('');
    this.propertyForm.get('selectedPropertyType')?.setValue('');
    this.dialogRef.close();
  }

  update() {
    if(this.propertyForm.valid){
      this.dialogRef.close({
        selectedPropertySize: this.propertyForm.value.selectedPropertySize,
        selectedPropertyType: this.propertyForm.value.selectedPropertyType,
      });
    } else {
      this.propertyForm.markAllAsTouched();
    }
  }
   getPropertySizeWithPropertyType() {
      this.customerDashboardService.gePropertySizeWithPropertyType.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any[])=>{
        if(res) {
          this.propertySizeWithPropertyType = res;
          this.propertySize = this.commonService.findPropertySizeByPropertyTypeId(this.data.selectedPropertyType, this.propertySizeWithPropertyType, false);
        }
      });
    };
  propertyTypeChange(event: MatSelectChange){
    this.propertyForm.get('selectedPropertySize')?.setValue('');
    this.propertySize = this.commonService.findPropertySizeByPropertyTypeId(event.value, this.propertySizeWithPropertyType, false);
    this.cdRef.detectChanges();
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
